import { BaseModel } from '../base-model';

export interface IAppointmentHistory {
  AppointmentId?: number;
  ChangedComments?: string;
  Id?: number;
  LogType?: number;
  LogTypeDescription?: string;
  ModifiedBy?: number;
  ModifiedByUserName?: string;
  ModifiedDate?: string
}
export class AppointmentHistory extends BaseModel<IAppointmentHistory> implements IAppointmentHistory {
  constructor(options?: IAppointmentHistory) {
    super(options);
  }
 }